"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("../forms/LoginForm"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const Login = (props) => {
    return (react_1.default.createElement("div", { className: "min-h-screen bg-white flex" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Anmelden")),
        react_1.default.createElement("div", { className: 'flex-col md:flex-row flex w-full' },
            react_1.default.createElement("div", { className: "order-2 sm:order-1 relative w-full flex-1 bg-primary-600" },
                react_1.default.createElement("img", { className: "absolute inset-0 h-full w-full object-cover opacity-80 ", src: '/imgs/login-bg.jpg', alt: "" })),
            react_1.default.createElement("div", { className: "order-1 sm:order-2 w-full md:w-1/2 lg:w-1/3 flex flex-col py-16 pt-24 px-4" },
                react_1.default.createElement("div", { className: "mx-auto w-full max-w-sm lg:w-96" },
                    react_1.default.createElement("div", { className: "flex justify-center" },
                        react_1.default.createElement("img", { className: "h-24 w-auto", src: "/imgs/logo-stauden.png", alt: "Workflow" })),
                    react_1.default.createElement("h2", { className: "mt-6 text-3xl font-extrabold text-gray-900 mb-6" }, "Melden Sie sich an"),
                    react_1.default.createElement(LoginForm_1.default, null))))));
};
exports.default = Login;
